import { merchantIcons } from '@assets/icons';
import { PROFILE_IMAGE_ACCEPT } from '@modules/merchant/profile/utils/validateProfileImage';
import { memo, useRef } from 'react';

const ProfileImageUpload = memo(({ preview, onChange, uploading = false }) => {
  const inputRef = useRef(null);

  const handleSelect = (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file || uploading) return;
    onChange(file);
  };

  const openFilePicker = () => {
    if (uploading) return;
    inputRef.current?.click();
  };

  return (
    <div className="flex w-full items-center gap-form">
      <button
        type="button"
        onClick={openFilePicker}
        disabled={uploading}
        className="flex size-[52px] shrink-0 cursor-pointer items-center justify-center rounded-full border border-dashed border-merchant-border-strong bg-white  outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-60 md:size-[66px] desktop:size-[88px] "
        aria-label="Upload profile image"
      >
        {preview ? (
          <img
            src={preview}
            alt="Profile preview"
            className="size-full rounded-full object-fill"
          />
        ) : (
          <img src={merchantIcons.user} alt="" className="icon-xl opacity-20" aria-hidden="true" />
        )}
      </button>

      <button
        type="button"
        onClick={openFilePicker}
        disabled={uploading}
        className="cursor-pointer desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-primary outline-none hover:underline focus:outline-none disabled:cursor-not-allowed disabled:opacity-60 disabled:no-underline"
      >
        {uploading ? 'Uploading...' : 'Upload image'}
      </button>

      <input
        ref={inputRef}
        type="file"
        accept={PROFILE_IMAGE_ACCEPT}
        onChange={handleSelect}
        className="hidden"
      />
    </div>
  );
});

ProfileImageUpload.displayName = 'ProfileImageUpload';

export default ProfileImageUpload;
